<template>
    <common-page flex-column card-content>
        <query-view :config-code="$_configCode"
                    enable-edit
                    with-custom-actions-head-of-row
                    :new-row-save-holder="{pjId: pjId}"
                    :enable-import="hasCode(pjId)"
                    :field-addition="fieldAddition"
                    custom-columns="requiredDate"
                    @linkClick="whenLinkClick">
            <template #leftHeader>
                <mini-button :loading="releaseLoading" :disable="$_notChecked" @btnClick="release">
                    Release
                </mini-button>
            </template>
            <template #headOfRow="{row}">
                <mini-button v-if="row.batchId" @btnClick="gotoReleaseBatch(row)">
                    <i class="fa-solid fa-right-long"></i>
                </mini-button>
            </template>
            <template #custom(requiredDate)="{row}">
                <div :class="requireDateDelay(row.requiredDate)?'text-danger':''">
                    {{ row.requiredDate }}
                </div>
            </template>
        </query-view>

        <template #outer>
            <query-view-modal ref="fileList" header="文件详情"
                              config-code="pj_doc_file"
                              :filter="fileFilter"
                              :field-addition="fileListFieldAddition"
                              @linkClick="whenLinkClick"/>
            <query-view-modal ref="downloadRecord" header="下载记录"
                              config-code="pj_download_record"
                              :filter="downloadRecordFilter"
                              enable-export/>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import QueryViewModal from "@/components/common/display/query-view/QueryViewModal.vue";

export default {
    name: "SithMomPjDocument",
    mixins: [miniTableCheckedMixin],
    components: {QueryViewModal, MiniButton, QueryView, CommonPage},
    data() {
        return {
            releaseLoading: false,
            fieldAddition: {
                // batchCode: {isLink: true},
                docNumber: {isLink: true},
            },
            fileFilter: {
                docNumber: null,
            },
            fileListFieldAddition: {
                fileName: {isLink: true},
                downloadCount: {isLink: true},
            },
            downloadRecordFilter: {
                fileId: null
            }
        }
    },
    computed: {
        pjId() {
            return this.$route.query.pjIdFilter;
        },
        $_configCode() {
            return 'pj_document';
        },
        endOfDay() {
            return new Date(new Date().setHours(23, 59, 59, 999));
        },
    },
    methods: {
        release() {
            if (this.$_checked) {
                this.releaseLoading = true;
                this.$store.dispatch("api/post", {
                    url: `${process.env.VUE_APP_SITHMES_II_URL}/sithMomPjDocument/release`,
                    data: this.checkedIdList
                }).then(res => {
                    this.$message.success("success");
                }).finally(() => this.releaseLoading = false);
            }
        },
        gotoReleaseBatch(row) {
            this.$router.push({
                name: 'sithMomPjRelease',
                query: {
                    docNumberFilter: row.docNumber
                }
            })
        },
        whenLinkClick(item) {
            let row = item.row;
            if (item.key === 'docNumber') {
                // this.$store.dispatch('queryViewStore/routeTo', 'pj_doc_file');
                this.fileFilter.docNumber = row.docNumber;
                this.$refs.fileList.showModal();
            } else if (item.key === 'batchCode') {
                this.$router.push({
                    name: 'sithMomPjRelease',
                    query: {
                        idFilter: row.batchId
                    }
                })
            } else if (item.key === 'fileName') {
                if (confirm(`确定要下载文件${row.fileName}吗？`)) {
                    this.downloadWithHeader(`${process.env.VUE_APP_SITHMES_II_URL}/pjDoc/download/one?fileId=${row.id}`, row.fileName);
                }
            } else if (item.key === 'downloadCount') {
                this.downloadRecordFilter.fileId = row.id;
                this.$refs.downloadRecord.showModal();
            }
        },

        requireDateDelay(date) {
            if (date) {
                try {
                    let target = new Date(date);
                    if (target <= this.endOfDay) {
                        return true;
                    }
                } catch (e) {
                    return false;
                }
            }
            return false;
        },
    }
}
</script>

<style scoped>

</style>
